import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { isChunkedMedia, decryptChunkedToBlob, decryptBytes } from "../lib/crypto";

const MIME = { image: "image/jpeg", audio: "audio/mpeg", video: "video/mp4" };

// Authenticated media loader, <img>/<video> can't send auth headers, so we
// fetch the (login-gated) file as a blob and hand back an object URL.
// When encKey (an imported AES CryptoKey) is supplied, the bytes are per-Beacon
// encrypted and decrypted on-device before playback.
export const BeaconMedia = ({ path, type, className, encKey, iv }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let live = true;
    let blob;
    if (!path) return;
    (async () => {
      try {
        const r = await api.get(`/files/${path}`, { responseType: "blob" });
        if (!live) return;
        if (!encKey) {
          blob = URL.createObjectURL(r.data);
          setUrl(blob);
          return;
        }
        const buf = await r.data.arrayBuffer();
        const mime = MIME[type] || "application/octet-stream";
        let outBlob;
        if (isChunkedMedia(buf)) {
          outBlob = await decryptChunkedToBlob(encKey, buf, mime);
        } else {
          const pt = await decryptBytes(encKey, buf, iv);
          outBlob = new Blob([pt], { type: mime });
        }
        if (!live) return;
        blob = URL.createObjectURL(outBlob);
        setUrl(blob);
      } catch { /* leave placeholder */ }
    })();
    return () => { live = false; if (blob) URL.revokeObjectURL(blob); };
  }, [path, encKey, iv, type]);
  if (!path) return null;
  if (!url) return <div className={`bg-white/5 animate-pulse ${className || ""}`} />;
  if (type === "video") return <video src={url} controls controlsList="nodownload" className={className} data-testid="beacon-media-video" />;
  if (type === "audio") return <audio src={url} controls controlsList="nodownload" className="w-full" data-testid="beacon-media-audio" />;
  return <img src={url} alt="" className={className} data-testid="beacon-media-img" />;
};
